import FetchHelpers from 'utils/FetchHelpers';
import { apiRoutes } from 'routes';

export default {
  index() {
    const url = apiRoutes.loanOfficerDashboardPath();

    return FetchHelpers.get(url);
  },
};



// WEBPACK FOOTER //
// ./src/repositories/loanOfficer/LoanOfficerDashboardRepository.js